<template>
  <div id="Lgx02714062714426965885402">
    <div class="relative flex justify-center">
      <img
        src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/casp-plus/02714062714426965885402/graphic.png"
        alt="Logo"
        draggable="false"
        width="100%"
        height="100%"
      />

      <span class="cursor-pointer" style="width: 12%; height: 24%; top: 5%; left: 0%; position: absolute" @click="selectedItemIndex = 0" />

      <span
        class="cursor-pointer"
        style="width: 11.75%; height: 15.5%; top: 18%; left: 20.8%; position: absolute"
        @click="selectedItemIndex = 1"
      />

      <span
        class="cursor-pointer"
        style="width: 11.75%; height: 19.5%; top: 46.8%; left: 0%; position: absolute"
        @click="selectedItemIndex = 2"
      />

      <span
        class="cursor-pointer"
        style="width: 10.5%; height: 4%; bottom: 42%; left: 19.6%; position: absolute"
        @click="selectedItemIndex = 3"
      />

      <span
        class="cursor-pointer"
        style="width: 10.5%; height: 4%; bottom: 42%; left: 49.05%; position: absolute"
        @click="selectedItemIndex = 4"
      />

      <span
        class="cursor-pointer"
        style="width: 11.75%; height: 19.2%; bottom: 4.2%; left: 0%; position: absolute"
        @click="selectedItemIndex = 5"
      />

      <span
        class="cursor-pointer"
        style="width: 11.75%; height: 15.3%; bottom: 6.5%; left: 20.5%; position: absolute"
        @click="selectedItemIndex = 6"
      />

      <span
        class="cursor-pointer"
        style="width: 11.75%; height: 15.3%; bottom: 6.5%; left: 41.6%; position: absolute"
        @click="selectedItemIndex = 7"
      />

      <span
        class="cursor-pointer"
        style="width: 3.75%; height: 15.3%; bottom: 6.5%; right: 21%; position: absolute"
        @click="selectedItemIndex = 8"
      />
    </div>

    <movable-popup
      refVal="remediationPopup"
      :title="`${items[selectedItemIndex]?.name || 'N/A'}`"
      :active="selectedItemIndex !== null && selectedItemIndex !== 8"
      v-on:close="selectedItemIndex = null"
      style="width: 68rem; max-width: none"
    >
      <template v-slot:content>
        <div class="flex gap-3">
          <div class="w-7/12 flex flex-col gap-1">
            <div class="cell header-cell flex gap-2">
              <span class="w-5/12">Findings</span>
              <span class="w-7/12">Status</span>
            </div>

            <div class="flex gap-1">
              <div class="flex flex-col gap-1 w-5/12">
                <span v-for="(finding, index) in items[selectedItemIndex].findings" :key="index" class="cell item-cell font-semibold">
                  {{ finding }}
                </span>
              </div>

              <div class="flex flex-col gap-1 w-7/12">
                <span
                  v-for="(status, index) in items[selectedItemIndex].status"
                  :key="index"
                  class="cell item-cell font-semibold text-grey"
                >
                  {{ status }}
                </span>
              </div>
            </div>
          </div>
          <div class="w-5/12 flex-col gap-1">
            <span class="cell remediations-header-cell flex gap-2">Remediations</span>
            <div class="flex flex-col w-full gap-1 mt-1">
              <span
                v-for="(remediation, index) in remediationOptions"
                :key="index"
                :class="`flex items-center font-semibold gap-1 cell ${
                  remediation === items[selectedItemIndex].remediationValue ? 'text-white' : 'text-grey'
                }
                ${
                  items[selectedItemIndex].correct === true && items[selectedItemIndex].remediationValue === remediation
                    ? 'correct-cell'
                    : 'remediations-cell'
                }
                `"
              >
                <vs-radio
                  v-model="items[selectedItemIndex].remediationValue"
                  :color="items[selectedItemIndex].correct === true ? 'success' : 'warning'"
                  class="cursor-pointer"
                  :vs-value="remediation"
                  :vs-name="remediation"
                  aria-label="No quiz timer selected"
                  @input="remediation"
                  :disabled="items[selectedItemIndex].correct === true"
                />
                {{ remediation }}
              </span>
            </div>
          </div>
        </div>
      </template>
    </movable-popup>

    <movable-popup
      refVal="serverPopup"
      :title="`${items[8]?.name || 'N/A'}`"
      :active="selectedItemIndex === 8"
      v-on:close="selectedItemIndex = null"
      style="width: 68rem; max-width: none"
    >
      <template v-slot:content>
        <div class="flex flex-col gap-5">
          <div class="flex flex-col gap-2 bg-dark p-3 rounded main-border">
            <div class="flex items-center">
              <vs-button
                class="font-bold mr-2"
                size="small"
                :color="items[8].topTab === 0 ? 'primary' : 'grey'"
                @click="items[8].topTab = 0"
                >Nmap</vs-button
              >
              <vs-button class="font-bold" size="small" :color="items[8].topTab ? 'primary' : 'grey'" @click="items[8].topTab = 1"
                >IP Tables</vs-button
              >
            </div>

            <div class="flex flex-col gap-3 mt-2">
              <div v-if="items[8].topTab === 0" class="text-grey terminal-line" v-html="items[8].nmapOutput" />
              <div v-if="items[8].topTab === 1" class="text-grey terminal-line" v-html="items[8].ipTablesOutput" />
            </div>
          </div>

          <div class="flex flex-col gap-2 bg-dark p-3 rounded main-border">
            <span>Please select the correct iptables rule to apply</span>

            <div class="flex gap-2">
              <vs-button
                class="font-bold"
                size="small"
                :color="items[8].ipTablesCorrect && items[8].ipTablesAnswer === 0 ? 'success' : items[8].bottomTab === 0 ? 'primary' : 'grey'"
                @click="selectIpTables(0)"
                :disabled="items[8].ipTablesCorrect"
                >1</vs-button
              >
              <vs-button
                class="font-bold"
                size="small"
                :color="items[8].ipTablesCorrect && items[8].ipTablesAnswer === 1 ? 'success' : items[8].bottomTab === 1 ? 'primary' : 'grey'"
                @click="selectIpTables(1)"
                :disabled="items[8].ipTablesCorrect"
                >2</vs-button
              >
              <vs-button
                class="font-bold"
                size="small"
                :color="items[8].ipTablesCorrect && items[8].ipTablesAnswer === 2 ? 'success' : items[8].bottomTab === 2 ? 'primary' : 'grey'"
                @click="selectIpTables(2)"
                :disabled="items[8].ipTablesCorrect"
                >3</vs-button
              >
              <vs-button
                class="font-bold"
                size="small"
                :color="items[8].ipTablesCorrect && items[8].ipTablesAnswer === 3 ? 'success' : items[8].bottomTab === 3 ? 'primary' : 'grey'"
                @click="selectIpTables(3)"
                :disabled="items[8].ipTablesCorrect"
                >4</vs-button
              >
            </div>

            <div class="flex flex-col gap-3 mt-2">
              <div v-if="items[8].bottomTab === 0" class="text-grey terminal-line" v-html="items[8].ipTables[0]" />
              <div v-if="items[8].bottomTab === 1" class="text-grey terminal-line" v-html="items[8].ipTables[1]" />
              <div v-if="items[8].bottomTab === 2" class="text-grey terminal-line" v-html="items[8].ipTables[2]" />
              <div v-if="items[8].bottomTab === 3" class="text-grey terminal-line" v-html="items[8].ipTables[3]" />
            </div>
          </div>
        </div>
      </template>
    </movable-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      selectedItemIndex: null,

      remediationOptions: [
        'No issue found',
        'Patch management',
        'Update endpoint protection',
        'Enable disk encryption',
        'Enable port security on network device',
        'Enable password complexity',
        'Enable host-based firewall to block all traffic',
        'Antivirus scan',
        'Change default administrative password',
        'Disable unneeded services',
        'Enable all connectivity settings',
      ],

      items: [
        {
          name: 'WAP A',
          findings: ['Firmware', 'Top 5 used ports', 'SSID broadcast', 'Default admin account', 'HTTP server'],
          status: ['Updated 5 days ago', '22, 80, 443, 123, 50', 'Disabled', 'Default password has been changed', 'Disabled'],
          remediationAnswer: 'No issue found',
          remediationValue: null,
          correct: null,
        },

        {
          name: 'PC A',
          findings: [
            'OS updates',
            'Endpoint protection',
            'Browser version',
            'Disk encryption',
            'Password complexity',
            'Host-based firewall',
            'CPU & memory usage',
            'Screensaver',
            'Top 5 used ports',
            'Wireless',
          ],
          status: [
            'Updated 2 days ago, last checked 5:08 AM',
            'Last checked 6:11 AM',
            '91.2.5 (7/31/2023)',
            'Enabled',
            'Enabled',
            'Disabled',
            'Normal',
            'Enabled',
            '22, 80, 443, 389, 53',
            'Disabled',
          ],
          remediationAnswer: 'Disable unneeded services',
          remediationValue: null,
          correct: null,
        },

        {
          name: 'Laptop A',
          findings: [
            'OS updates',
            'Endpoint protection',
            'Browser version',
            'Disk encryption',
            'Password complexity',
            'Host-based firewall',
            'CPU & memory usage',
            'Screensaver',
            'Top 5 used ports',
            'Wireless',
          ],
          status: [
            'Updated 3 days ago, last checked 6:08 AM',
            'Last checked 6:13 AM',
            '91.2.5 (7/31/2023)',
            'Enabled',
            'Enabled',
            'Disabled',
            'Medium',
            'Enabled',
            '22, 80, 443, 389, 53',
            'Enabled',
          ],
          remediationAnswer: 'No issue found',
          remediationValue: null,
          correct: null,
        },

        {
          name: 'Switch A',
          findings: ['Firmware', 'Top 5 used ports', 'Interfaces disabled (out of 12)', 'Default admin account', 'HTTP server'],
          status: ['Updated 7 days ago', '22, 80, 443, 123, 53', '4', 'Default password has not been changed', 'Disabled'],
          remediationAnswer: 'Change default administrative password',
          remediationValue: null,
          correct: null,
        },

        {
          name: 'Switch B',
          findings: ['Firmware', 'Top 5 used ports', 'Interfaces disabled (out of 6)', 'Default admin account', 'HTTP server'],
          status: ['Updated 7 days ago', '22, 80, 443, 123, 53', '1', 'Default password has not been changed', 'Disabled'],
          remediationAnswer: 'Change default administrative password',
          remediationValue: null,
          correct: null,
        },

        {
          name: 'Laptop B',
          findings: [
            'OS updates',
            'Endpoint protection',
            'Browser version',
            'Disk encryption',
            'Password complexity',
            'Host-based firewall',
            'CPU & memory usage',
            'Screensaver',
            'Top 5 used ports',
            'Wireless',
          ],
          status: [
            'Updated 3 days ago, last checked 8:08 AM',
            'Last checked 8:11 AM',
            '81.2.5 (7/31/2023)',
            'Disabled',
            'Enabled',
            'Disabled',
            'Normal',
            'Enabled',
            '22, 80, 443, 8080, 53',
            'Enabled',
          ],
          remediationAnswer: 'Enable disk encryption',
          remediationValue: null,
          correct: null,
        },

        {
          name: 'PC B',
          findings: [
            'OS updates',
            'Endpoint protection',
            'Browser version',
            'Disk encryption',
            'Password complexity',
            'Host-based firewall',
            'CPU & memory usage',
            'Screensaver',
            'Top 5 used ports',
            'Wireless',
          ],
          status: [
            'Updated 2 days ago, last checked 5:10 AM',
            'Last checked 6:13 AM',
            '91.2.5 (7/31/2023)',
            'Enabled',
            'Enabled',
            'Disabled',
            'Medium',
            'Enabled',
            '22, 80, 443, 389, 53',
            'Disabled',
          ],
          remediationAnswer: 'Disable unneeded services',
          remediationValue: null,
          correct: null,
        },

        {
          name: 'PC C',
          findings: [
            'OS updates',
            'Endpoint protection',
            'Browser version',
            'Disk encryption',
            'Password complexity',
            'Host-based firewall',
            'CPU & memory usage',
            'Screensaver',
            'Top 5 used ports',
            'Wireless',
          ],
          status: [
            'Updated 22 days ago',
            'Last checked 6:19 AM',
            '91.2.5 (7/18/2022)',
            'Enabled',
            'Enabled',
            'Disabled',
            'High',
            'Enabled',
            '22, 80, 443, 23, 53',
            'Disabled',
          ],
          remediationAnswer: 'Patch management',
          remediationValue: null,
          correct: null,
        },

        {
          name: 'Server A',
          topTab: 0,
          bottomTab: 0,
          ipTablesOutput: `
          #iptables --list --verbose<br /><br />
          Chain INPUT (policy DROP 5 packets, 341 bytes)<br /><br />
          
          pkts&nbsp;bytes&nbsp;&nbsp;target&nbsp;&nbsp;prot&nbsp;&nbsp;opt&nbsp;in&nbsp;&nbsp;out&nbsp;&nbsp;source&nbsp;&nbsp;&nbsp;&nbsp;destination<br /><br /> 
          0&nbsp;&nbsp;&nbsp;&nbsp;0&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ACCEPT&nbsp;&nbsp;tcp&nbsp;&nbsp;&nbsp;--&nbsp;&nbsp;any&nbsp;any&nbsp;&nbsp;anywhere&nbsp;&nbsp;anywhere&nbsp;&nbsp;&nbsp;&nbsp;tcp spts:login:65535 dpt:ssh state NEW,ESTABLISHED<br /><br /> 
          1&nbsp;&nbsp;&nbsp;&nbsp;28&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;DROP&nbsp;&nbsp;&nbsp;&nbsp;all&nbsp;&nbsp;&nbsp;--&nbsp;&nbsp;any&nbsp;any&nbsp;&nbsp;anywhere&nbsp;&nbsp;anywhere<br /><br /><br /><br />
          Chain FORWARD (policy DROP 0 packets, 0 bytes)
          `,
          nmapOutput: `
             Nmap scan report for psql-srvr.acme.com<br />
          Host is up, received atp-response (0.00040s latency).<br />
          ...<br />
          PORT&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;STATE&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SERVICE&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;VERSION<br />
          22/tcp&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;open&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ssh&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OpenSSH&nbsp;8.4<br />
          80/tcp&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;closed&nbsp;&nbsp;&nbsp;&nbsp;http<br />
          443/tcp&nbsp;&nbsp;&nbsp;&nbsp;closed&nbsp;&nbsp;&nbsp;&nbsp;ssl/http<br />
          1433/tcp&nbsp;&nbsp;&nbsp;closed&nbsp;&nbsp;&nbsp;&nbsp;mssql<br />
          5432/tcp&nbsp;&nbsp;&nbsp;closed&nbsp;&nbsp;&nbsp;&nbsp;postgresql<br />
          ...
          `,
          ipTables: [
            `
            iptables -R INPUT 1 -p tcp -s 10.1.2.25/32 --sport 4022 -j ACCEPT<br />
            iptables -D OUTPUT 1<br />
            iptables -A OUTPUT -p udp -d 0/0 -s 10.1.2.0/24 --sport 5432 -m state --state ESTABLISHED -j ACCEPT<br />
            iptables -A INPUT -p tcp -d 0/0 -s 10.1.2.0/24 --dport 5432 -m state --state NEW,ESTABLISHED -j ACCEPT
            `,
            `
            iptables -R INPUT 1 -p tcp -s 10.1.2.0/24 --dport 4022 -j ACCEPT<br />
            iptables -D OUTPUT 2<br />
            iptables -A OUTPUT -p tcp -d 0/0 -d 10.1.2.0/24 --sport 5432 -m state --state ESTABLISHED -j ACCEPT<br />
            iptables -A INPUT -p tcp -d 0/0 -d 10.1.2.0/24 --dport 5432 -m state --state NEW,ESTABLISHED -j ACCEPT
            `,
            `
            iptables -R INPUT 1 -p tcp -s 10.1.2.25/32 --sport 4022 -j ACCEPT<br />
            iptables -D OUTPUT<br />
            iptables -A OUTPUT -p tcp -d 0/0 -s 10.1.2.0/24 --sport 5432 -m state --state ESTABLISHED -j ACCEPT<br />
            iptables -A INPUT -p tcp -d 0/0 -d 10.1.2.0/24 --dport 5432 -m state --state NEW,ESTABLISHED -j ACCEPT
            `,
            `
            iptables -R INPUT 1 -p tcp -s 10.1.2.25/32 --dport 4022 -j ACCEPT<br />
            iptables -D OUTPUT 1<br />
            iptables -A OUTPUT -p tcp -d 0/0 -s 10.1.2.0/24 --sport 5432 -m state --state ESTABLISHED -j ACCEPT<br />
            iptables -A INPUT -p tcp -d 0/0 -s 10.1.2.0/24 --dport 5432 -m state --state NEW,ESTABLISHED -j ACCEPT
            `,
          ],
          ipTablesAnswer: 0,
          ipTablesValue: 0,
          ipTablesCorrect: null,
        },
      ],
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;

      if (this.items[8].ipTablesValue === this.items[8].ipTablesAnswer) {
        this.items[8].ipTablesCorrect = true;
        totalScore++;
      }

      this.items.forEach((item, index) => {
        if (index === 8) return;

        if (item.remediationValue === item.remediationAnswer) {
          item.correct = true;
          totalScore++;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
    selectIpTables(index) {
      this.items[8].bottomTab = index;
      this.items[8].ipTablesValue = index;
    },
  },
  components: {
    vSelect,
    MovablePopup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#Lgx02714062714426965885402 {
  .cursor-pointer {
    cursor: url('~@/assets/images/cursor/cursor-pointer.png'), auto !important;
  }

  .terminal-line {
    color: #f8f8f2;
    font-family: 'Fira Code', monospace;
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 0.25rem 0;
  }

  .cell {
    color: #fff;
    font-weight: 800;
    padding: 0.6rem;
    border-radius: 0.6rem;
  }

  .header-cell {
    background-color: rgb(0, 83, 255, 0.4);
    border: 1px solid rgb(0, 83, 255, 0.6);
  }

  .remediations-header-cell {
    background-color: rgba(255, 136, 0, 0.24);
    border: 1px solid rgb(255, 136, 0, 0.35);
  }

  .remediations-cell {
    background-color: rgba(255, 136, 0, 0.075);
  }

  .correct-cell {
    background-color: rgba(0, 255, 0, 0.075);
  }

  .item-cell {
    background-color: rgb(255, 255, 255, 0.08);
  }
}
</style>
